/* @jsx h */
import { defineComponent, h } from "vue";
import { RouterLink } from "vue-router";
import { useLocalization } from "@lemmonhq/uikit";
import { SignupStepper } from "./SignupStepper";
import type { SignupStep } from "./signupTypes";

type Props = {
  steps: SignupStep[];
  currentStep: number;
  onSelectStep: (index: number) => void;
};

export const SignupSidebar = defineComponent<Props>({
  name: "SignupSidebar",
  props: ["steps", "currentStep", "onSelectStep"],
  setup(props) {
    const { t } = useLocalization();
    return () => (
      <aside class="hidden w-[360px] shrink-0 flex-col gap-10 border-r border-base-300 bg-base-100 px-10 py-12 lg:flex">
        <div class="space-y-3">
          <h1 class="text-3xl font-semibold leading-tight text-accent">
            {t("signup.page.title")}
          </h1>
          <p class="text-sm leading-6 text-base-content/70">
            {t("signup.page.subtitle")}
          </p>
        </div>

        <SignupStepper
          steps={props.steps}
          currentStep={props.currentStep}
          onSelectStep={props.onSelectStep}
        />

        <p class="mt-auto text-sm text-base-content/60">
          {t("signup.page.have_account")}{" "}
          <RouterLink to="/login" class="link link-primary font-medium">
            {t("signup.page.login")}
          </RouterLink>
        </p>
      </aside>
    );
  },
});
